import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { ShoppingCart, Sparkle, ArrowsClockwise, Empty, ShieldWarning, WarningCircle, Prohibit, Info, XCircle, Warning, CheckCircle, TreeStructure, Database, ChartLine, Pulse, TrendUp, ChartBar, Flag, Clock, ClockCounterClockwise, Calendar, Archive, FileText, Envelope, ChatText, ListChecks, Lock, Key, Users, User, Briefcase, Buildings, Scales, CurrencyDollar, CreditCard, Invoice, Receipt, ClipboardText, Package, ShippingContainer, Truck, Airplane, Boat, Barcode, MapPin, Broadcast, Path, Crane, Anchor, Warehouse, Stack, Cube, Bell, Gear, MagnifyingGlass, House, SquaresFour, IconContext } from '@phosphor-icons/react';
export { Pulse as Activity, WarningCircle as AlertCircle, Warning as AlertTriangle, Anchor, Archive, ArrowDown, ArrowDownRight, ArrowLeft, ArrowRight, ArrowUp, ArrowUpRight, Medal as Award, Prohibit as Ban, ChartBar as BarChart, ChartBar as BarChart2, ChartBar as BarChart3, Bell, BellSlash as BellOff, BookOpen, Robot as Bot, Cube as Box, Cube as Boxes, Briefcase, Building, Buildings as Building2, Calculator, Calendar, CalendarCheck, CalendarCheck as CalendarCheck2, CalendarCheck as CalendarClock, CalendarDots as CalendarDays, Camera, Check, CheckCircle, CheckCircle as CheckCircle2, CheckSquare, CaretDown as ChevronDown, CaretLineLeft as ChevronFirst, CaretLineRight as ChevronLast, CaretLeft as ChevronLeft, CaretRight as ChevronRight, CaretUp as ChevronUp, CaretUpDown as ChevronsUpDown, Circle, WarningCircle as CircleAlert, CheckCircle as CircleCheck, Prohibit as CircleSlash, ClipboardText as ClipboardList, Clock, Clock as Clock3, ShippingContainer as Container, Copy, CreditCard, Database, CurrencyDollar as DollarSign, DownloadSimple as Download, PencilSimple as Edit, PencilSimple as Edit2, PencilSimpleLine as Edit3, DotsThreeVertical as EllipsisVertical, ArrowSquareOut as ExternalLink, Eye, File, ChartBar as FileBarChart, FileText as FileCheck, FileImage, FileMinus as FileMinus2, NotePencil as FilePen, FilePlus as FilePlus2, Files as FileStack, FileText, FileArrowUp as FileUp, FunnelSimple as Filter, Flag, GitBranch, Globe, DotsSixVertical as GripVertical, Heart, ClockCounterClockwise as History, House as Home, IconContext, Tray as Inbox, Info, Key, Stack as Layers, SquaresFour as LayoutDashboard, Leaf, Books as Library, LinkSimple as Link2, List, ListChecks, ListPlus, ListChecks as ListTodo, CircleNotch as Loader2, Lock, SignOut as LogOut, Envelope as Mail, MapPin, ArrowsOut as Maximize2, Question as MessageCircleQuestion, Chat as MessageSquare, NotePencil as MessageSquarePlus, ChatText as MessageSquareText, Signpost as Milestone, Minus, Moon, DotsThree as MoreHorizontal, DotsThreeVertical as MoreVertical, NavigationArrow as Navigation, TreeStructure as Network, Package, Package as Package2, Package as PackageCheck, StackMinus as PackageMinus, StackPlus as PackagePlus, Prohibit as PackageX, Palette, Sidebar as PanelLeft, SidebarSimple as PanelLeftClose, SidebarSimple as PanelLeftOpen, Layout as PanelsTopLeft, Paperclip, PauseCircle, PencilSimple as Pencil, PushPin as Pin, PushPinSlash as PinOff, Airplane as Plane, AirplaneTakeoff as PlaneTakeoff, Play, PlayCircle, Plus, PlusCircle, Presentation, Broadcast as Radar, Receipt as ReceiptText, ArrowsClockwise as RefreshCw, Repeat, ArrowCounterClockwise as RotateCcw, Ruler, Sailboat, Broadcast as Satellite, FloppyDisk as Save, Scales as Scale, Scan as ScanLine, MagnifyingGlass as Search, PaperPlaneTilt as Send, Gear as Settings, SlidersHorizontal as Settings2, Shield, ShieldWarning as ShieldAlert, ShieldCheck, Boat as Ship, ShoppingBag, ShoppingCart, SkipForward, Sliders, SlidersHorizontal, Sparkle as Sparkles, Star, Sun, Table, Table as Table2, Tag, Tag as Tags, Train as TrainFront, Trash as Trash2, TrendUp as TrendingUp, Warning as TriangleAlert, Trophy, Truck, ArrowUUpLeft as Undo2, LockOpen as Unlock, UploadSimple as Upload, CloudArrowUp as UploadCloud, User, UserCheck, UserGear as UserCog, UserMinus, UserPlus, UserCircle as UserRound, UserMinus as UserX, Users, MagicWand as WandSparkles, Warehouse, X, XCircle, Lightning as Zap, MagnifyingGlassPlus as ZoomIn, MagnifyingGlassMinus as ZoomOut } from '@phosphor-icons/react';

const iconRegistry = {
    dashboard: SquaresFour,
    home: House,
    search: MagnifyingGlass,
    settings: Gear,
    notifications: Bell,
    shipment: ShippingContainer,
    container: ShippingContainer,
    package: Package,
    product: Cube,
    inventory: Stack,
    warehouse: Warehouse,
    port: Anchor,
    terminal: Crane,
    route: Path,
    tracking: Broadcast,
    location: MapPin,
    barcode: Barcode,
    ocean: Boat,
    air: Airplane,
    truck: Truck,
    rail: ShippingContainer,
    courier: Package,
    order: ClipboardText,
    purchaseOrder: Receipt,
    invoice: Invoice,
    payment: CreditCard,
    currency: CurrencyDollar,
    cost: Scales,
    company: Buildings,
    vendor: Briefcase,
    user: User,
    team: Users,
    permission: Key,
    security: Lock,
    task: ListChecks,
    message: ChatText,
    email: Envelope,
    document: FileText,
    archive: Archive,
    calendar: Calendar,
    history: ClockCounterClockwise,
    pending: Clock,
    flag: Flag,
    analytics: ChartBar,
    trend: TrendUp,
    activity: Pulse,
    timeseries: ChartLine,
    dataSource: Database,
    workflow: TreeStructure,
    success: CheckCircle,
    warning: Warning,
    error: XCircle,
    info: Info,
    blocked: Prohibit,
    alert: WarningCircle,
    risk: ShieldWarning,
    empty: Empty,
    sync: ArrowsClockwise,
    ai: Sparkle,
    cart: ShoppingCart,
};
const Icon = React.forwardRef(({ name, ...props }, ref) => {
    const Glyph = iconRegistry[name];
    return jsx(Glyph, { ref: ref, ...props });
});
Icon.displayName = 'Icon';
function IconProvider({ children, size = 24, weight = 'regular', }) {
    const value = React.useMemo(() => ({ size, weight, mirrored: false }), [size, weight]);
    return jsx(IconContext.Provider, { value: value, children: children });
}

export { Icon, IconProvider, iconRegistry };
//# sourceMappingURL=index.js.map
